<div *ngIf="control !== undefined" class=" d-flex align-items-center error-container mb-0">
    <div *ngIf="(control?.errors && control?.dirty) || control.touched" class="Kerror">
        <small class="text-danger font-small" *ngIf="control.hasError('required')">{{label !== '' ? label : 'Field'}} is required</small>
        <small class="text-danger font-small" *ngIf="control.hasError('minlength')"> minimum length is {{ control.errors.minlength.requiredLength }} characters</small>
        <small class="text-danger font-small" *ngIf="control.hasError('maxlength')"> maximum length is {{ control.errors.maxlength.requiredLength }} characters</small>
        <small class="text-danger font-small" *ngIf="control.hasError('pattern')"> Invalid Value </small>
        <small class="text-danger font-small" *ngIf="control.hasError('noValidType')">Only Valid format supported</small>
        <small class="text-danger font-small" *ngIf="control.hasError('noValidSize')">file size limit</small>
        <!-- <small class="text-danger font-small" *ngIf="control.hasError('customError')">{{control.errors.customError}}</small> -->
        <small class="text-danger font-small" *ngIf="control.hasError('customError')">
            <ng-container *ngIf="control.errors.customError.length > 50; else shortError">
              {{ control.errors.customError | slice:0:86 }}<br/>
              {{ control.errors.customError | slice:86 }}
            </ng-container>
            <ng-template #shortError>
              {{ control.errors.customError }}
            </ng-template>
          </small>
    </div>
    <!-- <small class="error-space" *ngIf="(control.errors && control.dirty) || control.touched"></small> -->
</div>

